export enum ReportType {
  PROJECT_WORKITEMS = 'project-workitems',
  PROJECT_PEOPLE = 'project-people',
  PROJECT_PEOPLE_TOTALS = 'project-people-totals',
  PEOPLE_PROJECT = 'people-project',
}
